import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container, List } from '@pella/sash-framework';
import { CTA } from '../../';

import './index.css';

const AnchorNav = ({ data, className, ...other }) => {
	const [activeItem, setActiveItem] = useState('');
	const [activeAnchor, setActiveAnchor] = useState(false);

	useEffect(() => {
		if (!activeAnchor && 'IntersectionObserver' in window) {
			const sections = document.querySelectorAll('#content div[id]');
			const sectionsArr = [...sections];
			const options = {
				rootMargin: '0px 0px -80%',
				threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
			};
			const handleIntersection = (entries) => {
				for (let i = 0; i < entries.length; i++) {
					if (!activeItem && entries[i].isIntersecting) {
						setActiveItem(entries[i].target.id);
						setActiveAnchor('');
						break;
					} else if (activeItem === entries[i].target.id && !entries[i].isIntersecting) {
						setActiveItem('');
						break;
					}
				}
			};
			const observer = new IntersectionObserver(handleIntersection, options);
			if (sectionsArr?.[0]) {
				sectionsArr.filter((item) => item['id'] !== '').forEach((section) => observer.observe(section));
			}
			return () => observer.disconnect();
		}
	}, [activeItem, activeAnchor]);

	useEffect(() => {
		if (activeAnchor) {
			setTimeout(() => {
				setActiveAnchor(false);
			}, 1250);
		}
	}, [activeAnchor]);

	const onAnchorClick = (id) => {
		setActiveItem(id);
		setActiveAnchor(true);
	};

	return (
		<div
			className={`pal-anchorNav sticky top-0 z-10 bg-white transition-all sm:top-16 lg:z-[15] xl:top-[72px] ${className || ''}`}
			{...other}
		>
			<Container fluid={true}>
				<List
					bullets='none'
					layout='inline'
					className='pal-anchorNav-Links divide-x-gray-15 justify-center divide-x border-b border-b-gray-15'
				>
					{data.map((link, index) => (
						<li
							key={index}
							className={`relative my-1 !flex-1 py-1.5 text-center lg:!max-w-[200px] lg:!flex-[0_0_200px]`}
						>
							<CTA
								data={link}
								onClick={() => onAnchorClick(link.destination[0].destination.substring(1))}
								className={`relative inline-block font-semibold text-gray-50 no-underline before:absolute before:-bottom-2.5 before:left-0 before:h-[5px] before:w-full before:bg-primary hover:text-black hover:before:content-[""] focus:text-black focus:before:content-[""] ${activeItem === link.destination[0].destination.substring(1) ? 'active-anchor !text-black' : 'before:content-none'}`}
							/>
						</li>
					))}
				</List>
			</Container>
		</div>
	);
};

AnchorNav.propTypes = {
	data: PropTypes.array.isRequired,
	className: PropTypes.string,
};

export default AnchorNav;
